import React from "react";
import { Link } from "react-router-dom";
import { Lock, Check, Sparkles, ArrowRight } from "lucide-react";

const PRO_UNLOCKS = [
  "Winner Picker",
  "AMOE Portal",
  "Fraud Detection",
  "Success Score",
  "Analytics",
  "Unlimited giveaways",
];

export const UpgradePrompt = ({
  feature = "This",
  description = "Unlock this feature and grow faster with SweepLaunch Pro.",
  compact = false,
  testid = "upgrade-prompt",
}) => {
  return (
    <div
      data-testid={testid}
      className="relative overflow-hidden rounded-xl border border-emerald-200 bg-gradient-to-br from-emerald-50 via-white to-white p-6 sm:p-8"
    >
      <div className="pointer-events-none absolute -right-12 -top-12 size-44 rounded-full bg-emerald-200/40 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-16 -left-10 size-40 rounded-full bg-emerald-100/50 blur-3xl" />

      <div className="relative">
        <div className="inline-flex items-center gap-1.5 rounded-full bg-emerald-500/10 px-3 py-1 text-[10px] font-bold uppercase tracking-[0.18em] text-emerald-700">
          <Lock className="size-3" strokeWidth={2.5} /> Pro feature
        </div>

        <h3 className="mt-4 font-display text-xl sm:text-2xl font-bold text-zinc-950">
          {feature} is a Pro feature
        </h3>
        <p className="mt-2 max-w-md text-sm text-zinc-600">{description}</p>

        {!compact && (
          <ul className="mt-5 grid max-w-md grid-cols-1 gap-x-6 gap-y-2 sm:grid-cols-2">
            {PRO_UNLOCKS.map((f) => (
              <li key={f} className="flex items-center gap-2 text-sm text-zinc-700">
                <Check className="size-3.5 shrink-0 text-emerald-600" strokeWidth={2.5} /> {f}
              </li>
            ))}
          </ul>
        )}

        <div className="mt-6 flex flex-wrap items-center gap-3">
          <Link
            to="/billing"
            data-testid={`${testid}-cta`}
            className="group inline-flex items-center gap-2 rounded-md bg-emerald-500 px-5 py-2.5 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-emerald-600"
          >
            <Sparkles className="size-4" strokeWidth={2.5} />
            Upgrade to Pro — $79/mo
            <ArrowRight className="size-4 transition-transform group-hover:translate-x-0.5" strokeWidth={2.5} />
          </Link>
          <span className="text-xs text-zinc-500">2,000 orders/mo · Unlimited giveaways</span>
        </div>
      </div>
    </div>
  );
};

export default UpgradePrompt;
